import getAxiosInstance from '../../../../../../helpers/get_axios_instance'
import lrsAdapter from '../../../../../../helpers/lrs_adapter'

export class TablaCamionesPenalizadosService {
  static async getCamionesPenalizados () {
    const axios = getAxiosInstance()
    const tipoDeTransporte = 'camion'
    const promise = axios.get(`penalizacion_vigente_transporte_terrestre_listado?r=` +
      `{"clave": {"tipo_de_transporte" : "${tipoDeTransporte}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }
}
